define('plugin/promotion/view/PromotionClientInstanceItemView',['require','lib/view/LayoutView','lib/theme/ThemeSettings'],function (require) {

    var LayoutView = require('lib/view/LayoutView');
    var ThemeSettings = require('lib/theme/ThemeSettings');

    /**
     * Promotion instance info view (promotion instance item)
     *
     * @class PromotionClientInstanceItemView
     */
    return LayoutView.extend({

        getTemplate: function () {
            if (ThemeSettings.getInstance().getOption('display_item_mode') === 'list') {
                return '#promotion_client_instance_item_view_list';
            }
            return '#promotion_client_instance_item_view';
        },

        serializeData: function () {
            var data = LayoutView.prototype.serializeData.apply(this);
            data.highlighted = this.getOption('highlighted');

            return data;
        }

    });

});
